// custom.js
const ready = function () {
  // Initialize datepickers with jQuery UI options
  $(".datepicker").datepicker({
    dateFormat: "mm/dd/yy",
  });

  // Handle clickable table rows
  return $(".clickable-row").click(function () {
    return (window.document.location = $(this).attr("url"));
  });
};

$(document).ready(ready);
$(document).on("turbo:load", ready);
